import { useUpdatePropNew } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import { usePage } from 'client/store'
import {
  isBlogPageType,
  isWebsitePageType,
} from 'client/store/page/pageSelectors'
import {
  RedirectionTypesEnum,
  sendFormRedirectionChoices,
} from 'common/enums/ButtonActionEnum'
import { addUrlSchemaToTheLink } from 'common/utils/urlUtils'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { SettingsNestedMenu } from 'src/editor/layout/sidebar/settings/settings-nested-menu'
// import { SidebarBottomPortal } from 'src/editor/layout/sidebar/settings/sidebar-bottom-portal'
// import { AutomationRulesSettings } from 'src/editor/shared/settings/automation-rules-settings'
// import { CheckboxControl } from 'src/editor/shared/settings/checkbox-control'
import { TextInputControl } from 'src/editor/shared/settings/controls/text-input-control'
// import { AutomationRuleTriggersEnum } from 'src/editor/shared/types/automation-rules/triggers-types'
import { SelectNew } from 'src/editor/shared/ui-lib/select-new/select-new'
import { FormInterface } from 'src/shared/entities/form/form.schema'
import { SuccessOptInScreenSettings } from './success-opt-in-screen-settings'

interface FormDesignSettingsProps {
  entity: FormInterface
}

export const FormActionSettings = ({ entity }: FormDesignSettingsProps) => {
  const { t } = useTranslation()

  const updateProp = useUpdatePropNew(entity)

  const isBlogPage = usePage(isBlogPageType)
  const isWebsitePage = usePage(isWebsitePageType)

  const redirectionOptions = useMemo(() => {
    const options = [RedirectionTypesEnum.none, RedirectionTypesEnum.customUrl]
    if (!isBlogPage && !isWebsitePage) {
      options.push(RedirectionTypesEnum.nextStep)
    }
    return options.map(redirectionType => ({
      label: t(sendFormRedirectionChoices[redirectionType] ?? ''),
      value: redirectionType,
    }))
  }, [isBlogPage, isWebsitePage, t])

  return (
    <>
      <SelectNew
        labelText="entity_settings.button.send_form.redirection.label"
        selectedOption={
          redirectionOptions.find(
            option => option.value === entity.action?.redirectionType,
          ) ?? null
        }
        options={redirectionOptions}
        onChange={option =>
          option && updateProp('action', 'redirectionType')(option.value)
        }
      />
      {entity.action.redirectionType === RedirectionTypesEnum.none && (
        <SettingsNestedMenu
          menuTitle={t('entity_settings.form.success_opt_in_screen.label')}
          menuButtonLabel={t(
            'entity_settings.form.success_opt_in_screen.title',
          )}
        >
          <SuccessOptInScreenSettings entity={entity} />
        </SettingsNestedMenu>
      )}
      {entity.action?.redirectionType === RedirectionTypesEnum.customUrl && (
        <TextInputControl
          value={entity.action.urlRedirect}
          update={value =>
            updateProp('action', 'urlRedirect')(addUrlSchemaToTheLink(value))
          }
          wrapperProps={{
            labelText: 'Redirection url',
          }}
        />
      )}
      <GroupTitle />
      {/* TODO: uncomment it when the backend's ready
      <CheckboxControl
        label="entity_settings.button.send_model.double_opt_in.label"
        value={entity.action.doubleOptIn}
        update={updateProp('action', 'doubleOptIn')}
      /> */}
      {/* TODO: uncomment it when the backend's ready
      <SidebarBottomPortal>
        {isWebsitePage && (
          <AutomationRulesSettings
            entityId={entity.id}
            triggerKey={'formId'}
            triggerType={AutomationRuleTriggersEnum.website_form_subscribed}
          />
        )}
      </SidebarBottomPortal> */}
    </>
  )
}
